import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative px-4 md:px-6 py-6">
      <div className="relative w-full h-[420px] md:h-[600px] rounded-[24px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20manga%20collage%20artistic%20composition%20with%20vibrant%20comic%20panels%20characters%20and%20speech%20bubbles%20in%20warm%20coral%20and%20emerald%20green%20tones%20abstract%20stylized%20background%20with%20clean%20modern%20design%20aesthetic%20editorial%20quality&width=1600&height=900&seq=home-hero-bg-2026&orientation=landscape"
          alt="韩国漫画大全 - 免费在线韩漫阅读网"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55"></div>

        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
          <span className="inline-block px-4 py-1.5 rounded-full border border-background-50/40 text-background-50 text-sm font-medium mb-6 backdrop-blur-sm">
            热门连载 · 本周强推
          </span>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold font-heading text-background-50 leading-tight max-w-3xl">
            韩国漫画大全
            <br />
            <span className="font-semibold">免费在线韩漫阅读网</span>
          </h1>
          <p className="mt-5 text-sm md:text-base text-background-50/80 max-w-xl leading-relaxed">
            收录超万部经典韩漫作品，全部免费在线阅读，每日更新热门连载
          </p>
          <div className="flex items-center gap-3 mt-8">
            <Link
              to="/category/all?sort=newest"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-flashlight-line"></i>
              立即开始阅读
            </Link>
            <Link
              to="/category/all?status=completed"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-sm font-semibold border border-background-50/30 hover:bg-background-50/30 transition-colors whitespace-nowrap"
            >
              <i className="ri-check-double-line"></i>
              完结经典
            </Link>
          </div>

          <div className="flex items-center gap-6 mt-8 text-background-50/70 text-xs">
            <span className="flex items-center gap-1">
              <i className="ri-book-2-line"></i> 12,800+ 部作品
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-user-line"></i> 380万+ 月活用户
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i> 每日更新
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}